import PropTypes from 'prop-types';
import SearchOption from '../../../shared/components/SearchOption/SearchOption';
import SearchOptionButton from '../../../shared/components/SearchOption/SearchOptionButton';
import { DepartureFieldOverlay } from './DepartureFieldOverlay';

export const DepartureField = ({
  header,
  onChange,
  departures,
  selected,
  texts,
  isOpen,
  isOtherActive,
  onClose,
}) => {
  const value = selected.map((d) => d.name).join(', ');

  return (
    <>
      <SearchOption>
        <SearchOptionButton header={header} isOpen={isOpen} isOtherActive={isOtherActive} testSelector="lms-departure">
          {value}
        </SearchOptionButton>
      </SearchOption>
      <DepartureFieldOverlay
        isOpen={isOpen}
        selected={selected.map((x) => x.code)}
        departures={departures}
        texts={texts}
        onClose={onClose}
        onChange={onChange}
      />
    </>
  );
};

DepartureField.propTypes = {
  header: PropTypes.string,
  selected: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })),
  onChange: PropTypes.func.isRequired,
  departures: PropTypes.arrayOf(PropTypes.shape({ code: PropTypes.string, name: PropTypes.string })),
  texts: PropTypes.object,
  isOpen: PropTypes.bool,
  isOtherActive: PropTypes.bool,
  onClose: PropTypes.func,
};
